import type {Thread} from '@github-ui/diff-lines/conversation-types'

/**
 * Returns true if this review 'owns' this thread - that is, the thread was created by this review. A thread may also
 * appear under other reviews if a reply comment within that thread was created by the other review, but in that case
 * we don't consider the thread to be 'owned' by that review.
 */
export function isOwnedThread(reviewId: number, thread: Thread) {
  return thread.commentsData?.comments?.[0]?.reviewId === reviewId
}
